module.exports = __webpack_public_path__ + "9a84d3216b6b114bf4b2c898f91a6e2a.png";